export enum ApplicantStatus {
  NEW = 1,
  VIEWED = 2,
  INTERVIEW = 3,
  REMOVED = 4,
  SHORTLIST = 21,
  ACCEPTED = 22,
  OFFER = 23,
  RECOMMENDED = 24,
}

export interface ServerCompanyJobsFlowView {
  draft?: ApiSchema<'MyJobResult'>;
  inactive?: ApiSchema<'MyJobResult'>;
  active?: ApiSchema<'MyJobResult'>;
}
